var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFireIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 34,
    viewBox: "0 0 27 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.10805 10.3022C3.53627 10.7821 2.62719 11.7434 1.87468 13.0801C1.1214 14.4176 0.523901 16.1314 0.225547 17.7805C-0.0728067 19.4289 -0.0728014 21.0134 0.21153 22.7731C0.495862 24.5328 1.06376 26.4686 2.08969 28.1045C3.11562 29.7404 4.59803 31.0764 6.01501 31.9784C7.43122 32.8797 8.782 33.3471 10.3657 33.6587C11.9494 33.9703 13.7668 34.1261 15.5989 33.8753C17.4311 33.6252 19.2766 32.9678 20.8735 32.0073C22.4704 31.0468 23.8189 29.7817 24.7778 28.332C25.7375 26.8815 26.3093 25.2456 26.5555 23.584C26.8024 21.9217 26.7245 20.2344 26.3218 18.8322C25.9198 17.43 25.1922 16.3129 24.6469 15.7287C24.1016 15.1444 23.7386 15.093 23.5049 15.2488C23.2712 15.4046 23.1668 15.7676 22.997 16.1384C22.8264 16.5092 22.5904 16.887 22.2383 17.1799C21.8862 17.4728 21.4188 17.6801 20.9382 17.6154C20.4583 17.5507 19.9644 17.2127 19.758 16.401C19.5523 15.5885 19.6326 14.3024 19.8032 13.049C19.973 11.7948 20.2332 10.5749 20.181 9.25059C20.1288 7.92631 19.7658 6.49764 19.0249 5.13441C18.2849 3.77117 17.1686 2.47337 15.8833 1.61648C14.5979 0.759591 13.1436 0.343613 12.1441 0.148865C11.1447 -0.045883 10.5994 -0.0193999 10.2488 0.0584992C9.89829 0.136398 9.7425 0.265713 9.89829 0.61626C10.0541 0.966806 10.5215 1.53858 10.8588 2.39547C11.1969 3.25236 11.4041 4.39437 11.274 5.45925C11.1447 6.52413 10.6773 7.51033 9.85934 8.56197C9.0414 9.61361 7.87291 10.7307 7.10638 11.9895C6.34063 13.2492 5.97763 14.6513 5.84754 15.495C5.71745 16.3394 5.82105 16.6245 5.7042 16.4298C5.58735 16.235 5.25004 15.5604 5.09268 14.7105C4.93611 13.8607 4.9587 12.8363 5.0366 12.0705C5.1145 11.304 5.24771 10.7969 5.27497 10.465C5.30224 10.1332 5.22435 9.9774 5.06855 9.8995C4.91275 9.8216 4.67905 9.8216 4.10805 10.3022Z",
    fill: "url(#paint0_linear_7_4178)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.85803 23.5264C7.58694 23.8691 7.14604 24.7525 6.98868 25.967C6.83132 27.1814 6.95831 28.7277 7.50204 29.9554C8.04578 31.1831 9.00704 32.0914 10.0602 32.6297C11.1127 33.168 12.2586 33.3354 13.4543 33.3541C14.6501 33.3728 15.8964 33.2435 16.9738 32.7107C18.0511 32.1786 18.9602 31.2438 19.5055 30.1533C20.0508 29.0627 20.2331 27.8163 20.0508 26.5831C19.8693 25.3492 19.324 24.1293 18.4671 22.8175C17.6102 21.5065 16.4417 20.1043 15.7921 18.7932C15.1432 17.4814 15.0131 16.2615 15.1564 15.1187C15.299 13.9759 15.7142 12.9118 15.7796 12.3923C15.8443 11.8727 15.5591 11.8992 14.9344 12.3868C14.3096 12.8737 13.346 13.8233 12.5413 14.9528C11.7359 16.0823 11.0901 17.3918 10.7278 18.6966C10.3656 20.0007 10.2877 21.2985 10.3524 22.2722C10.4178 23.2459 10.625 23.8956 10.6507 24.4144C10.6772 24.934 10.5214 25.3235 10.2083 25.4217C9.8951 25.5198 9.42536 25.3259 9.08572 24.9699C8.74686 24.6131 8.53965 24.0943 8.38463 23.7359C8.23039 23.3784 8.1299 23.1828 7.85803 23.5264Z",
    fill: "url(#paint1_linear_7_4178)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_4178",
    x1: 13.0057,
    y1: 1.13974,
    x2: 13.0065,
    y2: 33.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA403A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7_4178",
    x1: 14.876,
    y1: 24.5874,
    x2: 14.876,
    y2: 33.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619608,
    stopColor: "#FFBC30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9502"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireIcon);
export default __webpack_public_path__ + "static/media/FireIcon.1e1242af94a260e95e295f31bb249b3a.svg";
export { ForwardRef as ReactComponent };